module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/messaging_desktop-2d7493b357865d80650182ad8f2c2456.png";